const ContentBlock = (props) => {
	return (
		<div className="w-11/12 m-auto border-solid border-2 border-dark-yellow bg-yellow-50 rounded-lg p-3 mt-4">{props.children}</div>
	);
}
 
export default ContentBlock;